import React from 'react';
import styles from './LogoIcon.module.scss';
import Img from '../../images/logo.png';

export default function Logo({ size }) {
  return (
    <img
      className={styles.img}
      src={Img}
      alt="Traffix Devices – Sentinel"
      width={size}
    />
  );
}
